import { render, staticRenderFns } from "./BriefcaseAccountOutline.vue?vue&type=template&id=bf8eb86e&"
import script from "./BriefcaseAccountOutline.vue?vue&type=script&lang=js&"
export * from "./BriefcaseAccountOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports